export default "c407ec52c3146250.svg"